
import {
    Circle as CircleStyle,
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text
} from 'ol/style.js';
import { LineString, Point } from 'ol/geom.js';


const style = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
        color: 'rgba(255, 0, 0, 0.7)',
        lineDash: [10, 10],
        width: 2,
    }),
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            width: 2,
            color: 'rgba(255, 0, 0, 0.7)',
        }),
        fill: new Fill({
            color: 'rgba(255, 128, 0, 0.7)',
        }),
    }),
});

const labelStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.8)',
        }),
        padding: [3, 3, 3, 3],
        textBaseline: 'bottom',
        offsetY: -15,
    }),
    image: new RegularShape({
        radius: 8,
        points: 3,
        angle: Math.PI,
        displacement: [0, 10],
        fill: new Fill({
            color: 'rgba(0, 0, 0, 0.8)',
        }),
    }),
});

const segmentStyle = new Style({
    text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(255, 255, 255, 1)',
        }),
        backgroundFill: new Fill({
            color: 'rgba(0, 0, 0, 0.6)',
        }),
        padding: [2, 2, 2, 2],
        textBaseline: 'bottom',
        offsetY: 0,
    })
});

const segmentStyles = [segmentStyle];

const pointStyle = new Style({
    image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
            width: 2,
            color: 'rgba(255, 0, 0, 0.7)',
        }),
        fill: new Fill({
            color: 'rgba(255, 128, 0, 0.7)',
        }),
    }),
});

const formatLength = function (line) {
    const length = line.getLength();
    let output;
    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + ' km';
    } else {
        output = Math.round(length * 100) / 100 + ' m';
    }
    return output;
};

const formatArea = function (polygon) {
    const area = polygon.getArea();
    let output;
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    } else {
        output = Math.round(area * 100) / 100 + ' m\xB2';
    }
    return output;
};

function styleFunctionDefault(feature, segments, drawType, tip) {
    const styles = [style];
    const geometry = feature.getGeometry();
    const type = geometry.getType();
    let point, label, line;
    if (!drawType || drawType === type) {
        if (type === 'Polygon') {
            point = geometry.getInteriorPoint();
            label = formatArea(geometry);
            line = new LineString(geometry.getCoordinates()[0]);
        } else if (type === 'LineString') {
            point = new Point(geometry.getLastCoordinate());
            label = formatLength(geometry);
            line = geometry;
        }
    }

    if (segments && line) {
        let count = 0;
        line.forEachSegment(function (a, b) {
            const segment = new LineString([a, b]);
            const label = formatLength(segment);
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(segmentStyle.clone());
            }
            const segmentPoint = new Point(segment.getCoordinateAt(0.5));
            segmentStyles[count].setGeometry(segmentPoint);
            segmentStyles[count].getText().setText(label);
            styles.push(segmentStyles[count]);
            count++;
        });

        line.getCoordinates().forEach(item => {
            const point = new Point(item);
            let style = pointStyle.clone();
            style.setGeometry(point);
            styles.push(style);
        });
    }
    if (label) {
        labelStyle.setGeometry(point);
        labelStyle.getText().setText(label);
        styles.push(labelStyle);
    }
    return styles;
}

function styleFunctionPoint(feature, segments, drawType, tip) {
    const styles = [];
    const geometry = feature.getGeometry();
    if (geometry.getType() === 'LineString') {
        geometry.getCoordinates().forEach(item => {
            const point = new Point(item);
            let style = pointStyle.clone();
            style.setGeometry(point);
            styles.push(style);
        });
    } else {
        let style = pointStyle.clone();
        style.setGeometry(geometry);
        styles.push(style);
    }
    return styles;
}

export function styleFunction(feature, segments, drawType, tip) {
    if (drawType === 'Point') {
        return styleFunctionPoint(feature, segments, drawType, tip);
    } else {
        return styleFunctionDefault(feature, segments, drawType, tip);
    }
}
